import './RegistrationInfo.less';
import React from 'react';
import { Button } from '../../button/Button';
import MinHeightPage from './MinHeightPage';
import ArcPage from './ArcPage';

function RegistrationInfo({ icon, buttonLabel, title, subTitle, onClick, loading, children }) {
    return (
        <>
            <MinHeightPage>
                <ArcPage>
                    <ArcPage.Top>
                        <div className="registration-info-icon">{icon}</div>
                    </ArcPage.Top>
                    <ArcPage.Body>
                        <h1>{title}</h1>
                        <h2>{subTitle}</h2>
                    </ArcPage.Body>
                </ArcPage>
                {children}
            </MinHeightPage>
            {onClick && (
                <div>
                    <div className="registration-info-end">
                        <div className="nui-input p-rel mb-20 flex flex-col">
                            <Button
                                className="nui-button-center nui-button-max-300"
                                primary
                                large
                                onClick={onClick}
                                label={buttonLabel}
                                loading={loading}
                            />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default RegistrationInfo;
